import { Component, Fragment } from 'preact'
import Button from 'preact-material-components/Button'
import Select from 'preact-material-components/Select'
import Typography from 'preact-material-components/Typography'
import { connect } from 'preact-redux'
import { addToShoppingCart, removeShoppingCartItem, updateShoppingCartItem } from '../../modules/shoppingCart'
import CategoryImage from './CategoryImage'
import { withNamespaces } from 'react-i18next'
import styles from './CategoryItem.scss'
import i18n from '../../i18n'
import { formatMonthTitle } from '../Datepicker/LocaleUtils'

@connect(
    null,
    { addToShoppingCart, removeShoppingCartItem, updateShoppingCartItem }
)
class CategoryItem extends Component {
    state = {
        booked: false,
        chosenIndex: 0
    }

    handleBook = () => {
        this.setState({ booked: true })

        const { category } = this.props

        this.props.addToShoppingCart({
            id: category.id,
            name: category.name,
            count: 1,
            price: category.price,
            currency: category.currency
        })

        this.setState({ chosenIndex: 1 })
    }

    handleSelectChange = e => {
        const index = e.target.selectedIndex
        const { category } = this.props

        if (index === 0) {
            this.props.removeShoppingCartItem(category.id)
            this.setState({ chosenIndex: 0, booked: false })
        } else {
            this.props.updateShoppingCartItem({
                ...category,
                count: index
            })
            this.setState({ chosenIndex: index })
        }
    }

    render({ category }, { booked, chosenIndex }) {
        const availabilityNumberArray = Array.from({ length: category.availability }, (v, k) => k + 1)

        const { t } = this.props

        const description = category.description ? category.description : ''

        const parsedString = description.split('\n')

        const parsedData = parsedString.map((item, i) => (
            <Fragment key={i }>
                <p>{item}</p>
                {i + 1 >= parsedString.length && <br />}
            </Fragment>
        ))

        return (
            <div class={styles.categoryItem}>
                <CategoryImage class={styles.categoryImage} images={category.images} />

                <div class={styles.categoryContent}>
                    <Typography headline6>{category.name}</Typography>

                    <div class={styles.categoryAvailability}>
                        <span class={styles.categoryAvailabilityText}>
                            {t('CategoryItem.available')}
                            <b>{category.availability}</b>
                        </span>
                    </div>

                    <div class={styles.categoryDescription}>{parsedData.map(item => item)}</div>

                    <div class={styles.categoryFooter}>
                        <div class={styles.price}>
                            <b>
                                {category.currency} {category.price.toFixed(2)}
                            </b>
                        </div>

                        {booked ? (
                            <div class={styles.selectWrapper}>
                                <label>{t('CategoryItem.indicatequantity')}</label>
                                <Select
                                    outlined
                                    class={styles.countSelect}
                                    selectedIndex={chosenIndex}
                                    onChange={this.handleSelectChange}
                                >
                                    <Select.Item>{t('common.cancel')}</Select.Item>
                                    {availabilityNumberArray.map(item => (
                                        <Select.Item key={item}>
                                            {item} ({category.currency} {(category.price * item).toFixed(2)})
                                        </Select.Item>
                                    ))}
                                </Select>
                            </div>
                        ) : (
                            <Button class={styles.bookButton} raised onClick={this.handleBook}>
                                {t('common.booknow')}
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default withNamespaces()(CategoryItem)



// WEBPACK FOOTER //
// ./components/CategoryItem/CategoryItem.js